import { supabase } from '@/integrations/supabase/client';
import { MessageInsertPayload, RealtimeAdapter } from './RealtimeAdapter';

export class SupabaseRealtimeAdapter implements RealtimeAdapter {
  subscribeToConversation(
    conversationId: string,
    onInsert: (payload: MessageInsertPayload) => void,
  ): () => void {
    const channel = supabase
      .channel(`conversation-${conversationId}`)
      .on(
        'postgres_changes',
        {
          event:  'INSERT',
          schema: 'public',
          table:  'messages',
          filter: `conversation_id=eq.${conversationId}`,
        },
        (event) => {
          onInsert({
            sender_id:       event.new.sender_id       as string,
            conversation_id: event.new.conversation_id as string,
          });
        },
      )
      .subscribe();

    return () => { supabase.removeChannel(channel); };
  }

  subscribeToUserMessages(
    userId: string,
    onInsert: (payload: MessageInsertPayload) => void,
  ): () => void {
    // No explicit filter here — Supabase Realtime + RLS delivers only rows the
    // authenticated user can SELECT (i.e. messages in their conversations).
    const channel = supabase
      .channel(`global-messages-${userId}`)
      .on(
        'postgres_changes',
        { event: 'INSERT', schema: 'public', table: 'messages' },
        (event) => {
          onInsert({
            sender_id:       event.new.sender_id       as string,
            conversation_id: event.new.conversation_id as string,
          });
        },
      )
      .subscribe();

    return () => { supabase.removeChannel(channel); };
  }
}
